function capitalizeFirstLetter(string) {
  if (string) {
    return string[0].toUpperCase() + string.slice(1);
  } else {
    return '';
  }
}

function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

function randomMsg(bestScore, order, prMsg, messages) {
  if ((!bestScore && order == 3) || (!bestScore && order >= 4 && !prMsg)) {
    // fit20['prBestScore' + memberId] = false;

    let randomNum = Math.floor(Math.random() * messages.length);
    // if (randomNum < 10) {
    //   randomNum = '0' + randomNum;
    // }

    return messages[randomNum];
  }
  return '';
}

function setMachineSettingImage(memberMachineSetting, machineId, studioId, studioMachines) {
  let settings = [{}, {}, {}, {}, {}, {}];
  let machine = memberMachineSetting.find(
    (machine) => machine.machineId == machineId && machine.studioId == studioId,
  );
  if (machineId == '3001') {
    // chest press
    settings[0].image = machine && machine.values[2] == 1 ? '0020' : '^0020';
    settings[1].image = '^0002';
    settings[1].value = machine && machine.values && machine.values[1] ? machine.values[1] : 0;
    settings[1].values = studioMachines
      .find((machine) => machine.id == '3001')
      .adjustable[1].values.split(' ');
    settings[2].image = '^0006';
    settings[2].value = machine && machine.values && machine.values[0] ? machine.values[0] : 0;
    settings[2].values = studioMachines
      .find((machine) => machine.id == '3001')
      .adjustable[0].values.split(' ');
    settings[3].image = machine && machine.values[3] == 1 ? '0012' : '^0012';
    settings[4].image = machine && machine.values[4] == 1 ? '0028' : '^0028';
    settings[5].image = machine && machine.sensor ? 'sensor-green' : 'sensor-red';
  }
  if (machineId == '5001') {
    // latpull
    settings[0].image = '^0008';
    settings[0].value = machine && machine.values && machine.values[1] ? machine.values[1] : 0;
    settings[0].values = studioMachines
      .find((machine) => machine.id == '5001')
      .adjustable[1].values.split(' ');
    settings[1].image = '^0002';
    settings[1].value = machine && machine.values && machine.values[0] ? machine.values[0] : 0;
    settings[1].values = studioMachines
      .find((machine) => machine.id == '5001')
      .adjustable[0].values.split(' ');
    settings[5].image = machine && machine.sensor ? 'sensor-green' : 'sensor-red';
  }
  if (machineId == '1001') {
    // leg press
    settings[1].image = '^0002';
    settings[1].value = machine && machine.values && machine.values[1] ? machine.values[1] : 0;
    settings[1].values = studioMachines
      .find((machine) => machine.id == '1001')
      .adjustable[1].values.split(' ');
    settings[2].image = '^0006';
    settings[2].value = machine && machine.values && machine.values[0] ? machine.values[0] : 0;
    settings[2].values = studioMachines
      .find((machine) => machine.id == '1001')
      .adjustable[0].values.split(' ');
    settings[5].image = machine && machine.sensor ? 'sensor-green' : 'sensor-red';
  }
  if (machineId == '4001') {
    //abdominal
    settings[1].image = '^0002';
    settings[1].value = machine && machine.values && machine.values[0] ? machine.values[0] : 0;
    settings[1].values = studioMachines
      .find((machine) => machine.id == '4001')
      .adjustable[0].values.split(' ');
    settings[4].image = machine && machine.values[1] == 1 ? '0028' : '^0028';
    settings[5].image = machine && machine.sensor ? 'sensor-green' : 'sensor-red';
  }
  if (machineId == '1002') {
    // back extinction
    settings[0].image = '^0004';
    settings[0].value = machine && machine.values && machine.values[1] ? machine.values[1] : 0;
    settings[0].values = studioMachines
      .find((machine) => machine.id == '1002')
      .adjustable[1].values.split(' ');
    settings[1].image = '^0002';
    settings[1].value = machine && machine.values && machine.values[0] ? machine.values[0] : 0;
    settings[1].values = studioMachines
      .find((machine) => machine.id == '1002')
      .adjustable[0].values.split(' ');
    settings[3].image = machine && machine.values[3] == 1 ? '0044' : '^0044';
    // settings[3].value = machine && machine.values && machine.values[3] ? machine.values[3] : 0;
    settings[4].image = machine && machine.values[2] == 1 ? '0028' : '^0028';
    settings[5].image = machine && machine.sensor ? 'sensor-green' : 'sensor-red';
  }
  if (machineId == '4002') {
    // adduction
    settings[0].image = '^0026';
    settings[0].value = machine && machine.values && machine.values[0] ? machine.values[0] : 0;
    settings[0].values = studioMachines
      .find((machine) => machine.id == '4002')
      .adjustable[0].values.split(' ');
    settings[3].image = machine && machine.values[1] == 1 ? '0032' : '^0032';
    settings[4].image = machine && machine.values[2] == 1 ? '0036' : '^0036';
    settings[5].image = machine && machine.sensor ? 'sensor-green' : 'sensor-red';
  }
  if (machineId == '2002') {
    // abduction
    settings[3].image = machine && machine.values[1] == 1 ? '0032' : '^0032';
    settings[4].image = machine && machine.values[0] == 1 ? '0036' : '^0036';
    settings[5].image = machine && machine.sensor ? 'sensor-green' : 'sensor-red';
  }
  if (machineId == '5872645769789440') {
    // mid row
    settings[0].image = '^0042';
    settings[0].value = machine && machine.values && machine.values[0] ? machine.values[0] : 0;
    settings[0].values = studioMachines
      .find((machine) => machine.id == '5872645769789440')
      .adjustable[0].values.split(' ');
    settings[1].image = '^0002';
    settings[1].value = machine && machine.values && machine.values[1] ? machine.values[1] : 0;
    settings[1].values = studioMachines
      .find((machine) => machine.id == '5872645769789440')
      .adjustable[1].values.split(' ');
  }
  if (machineId == '5002') {
    // RC
    settings[0].image = '^0022';
    settings[0].value = machine && machine.values && machine.values[0] ? machine.values[0] : 0;
    settings[0].values = studioMachines
      .find((machine) => machine.id == '5002')
      .adjustable[0].values.split(' ');
    settings[1].image = '^0024';
    settings[1].value = machine && machine.values && machine.values[1] ? machine.values[1] : 0;
    settings[1].values = studioMachines
      .find((machine) => machine.id == '5002')
      .adjustable[1].values.split(' ');
  }
  if (machineId == '707003' || machineId == '712001' || machineId == '725087') {
    // TL,TR, TS
    settings[0].image = '^0026';
    settings[0].value = machine && machine.values && machine.values[0] ? machine.values[0] : 0;
    settings[0].values = studioMachines
      .find((machine) => machine.id == machineId)
      .adjustable[0].values.split(' ');
    settings[3].image = machine && machine.values[1] == 1 ? '0012' : '^0012';
  }
  return settings;
}

function setMachineSetting(memberMachineSetting, studioMachines, studioId) {
  let machineSetting = {};
  let executeMachine = {};
  studioMachines.map((machine) => {
    machineSetting[String(machine.id)] = setMachineSettingImage(
      memberMachineSetting,
      machine.id,
      studioId,
      studioMachines,
    );
    let setting = memberMachineSetting.find(
      (machines) => machines.machineId == machine.id && machines.studioId == studioId,
    );
    if (setting) {
      executeMachine[String(machine.id)] = setting.execute;
    } else {
      executeMachine[String(machine.id)] = 0;
    }
  });
  return { machineSetting, executeMachine };
}

function secondsToTime(seconds) {
  let minutes = Math.floor(seconds / 60);
  let remainingSeconds = seconds % 60;

  // Use template literals to format the time
  return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
}
function getWeekYear(dateString) {
  const date = new Date(dateString);
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return d.getUTCFullYear() + ' - ' + Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
}
function getDay(dateString) {
  const date = new Date(dateString);
  const day = date.getDate();
  return day;
}
function getMonth(dateString) {
  const date = new Date(dateString);
  const month = date
    .toLocaleDateString('en-US', {
      month: 'short',
    })
    .toUpperCase();
  return month;
}

async function getStudioReportStr(
  dataToDisplay,
  studioMachines,
  studioId,
  storageBaseUrl,
  studioName,
) {
  async function fetchImageAsBase64(url) {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (err) {
      return '';
    }
  }

  const machineNames = [
    'Abdominals',
    'Abduction',
    'Adduction',
    'Back Extension',
    'Chest Press',
    'Lat Pull',
    'Leg Press',
    'Mid Row',
    'Roman Chair',
    'Torso Left',
    'Torso Right',
    'Torso Swing',
  ];

  const machineSettings = [
    '0012',
    '0020',
    '0028',
    '0032',
    '0036',
    '0044',
    '^0002',
    '^0004',
    '^0006',
    '^0008',
    '^0012',
    '^0020',
    '^0022',
    '^0024',
    '^0026',
    '^0028',
    '^0032',
    '^0036',
    '^0042',
    '^0044',
    'execute1',
    'execute2',
    'sensor-green',
    'sensor-red',
    'LESS',
    'MORE',
    'SAME',
    'fit20-logo',
  ];

  let machinesImages = {};
  let machineSettingsImages = {};

  await Promise.all([
    ...machineNames.map(async (name) => {
      machinesImages[name] = await fetchImageAsBase64(`${storageBaseUrl}/machine/${name}.svg`);
    }),
    ...machineSettings.map(async (setting) => {
      let format = '.svg';
      let path = '/machine-setting/';
      if (setting == 'LESS' || setting == 'MORE' || setting == 'SAME') {
        path = '/static/icons/';
      }
      if (setting == 'fit20-logo') {
        path = '/static/images/';
        format = '.png';
      }
      machineSettingsImages[setting] = await fetchImageAsBase64(
        `${storageBaseUrl + path + setting + format}`,
      );
    }),
  ]);

  let getMemberMachineSetting = (memberMachineSetting, machineId) => {
    let { machineSetting } = setMachineSetting(memberMachineSetting, studioMachines, studioId);
    return machineSetting[machineId]
      .map(
        (item) =>
          `<div class="machine-box-img-settings">
              ${item && item.image ? `<img src="${machineSettingsImages[item.image]}" />` : ``}
              ${item && item.value ? `<span >${item.value}</span>` : ``}
         </div>`,
      )
      .join('');
  };

  let getExecuteMachineSetting = (memberMachineSetting, id) => {
    let { executeMachine } = setMachineSetting(memberMachineSetting, studioMachines, studioId);
    return executeMachine[id];
  };

  const htmlContent = `
    <!DOCTYPE html>
    <html>
      <head>
      <title>Studio report</title>
      <style type="text/css" media="print">
        @media print {
          .non-printable {
            display: none !important;
          }
          .printable {
            display: block !important;
          }
        }
      </style>
      <style>
      body{
        max-width: 1200px;
        margin: auto;
      }
        .names-container {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
        }
        .names-container a {
          font-size: 14px;
          padding: 3px 10px;
          margin-left: 5px;
          width: calc(100% / 6 - 30px);
          border: solid 1px #0000002f;
          border-radius: 5px;
          margin-top: 5px;
          text-decoration: none;
          color: #009efb;
          transition: all 0.5s;
        }
        .names-container a:hover {
          border: solid 1px #0000002f;
          color: white;
          background-color: #009efb;
        }
        .session-title {
          display: flex;
          justify-content: space-between;
          padding: 10px;
        }
        .print-btn {
          border: solid 1px rgb(255, 255, 255);
          padding: 5px 10px;
          border-radius: 5px;
          background-color: #009efb;
          color: white;
        }
        .table-container {
          left: 0;
          /* position: absolute; */
          display: contents;
          direction: rtl;
        }
  
        /* Table styles */
        .table-container table {
          width: max-content;
          /* overflow-y: scroll; */
          /* height: calc(100% - 40px); */
        }
  
        /* Table header styles */
        .table-container th {
          padding: 1px 4px;
          padding-top: 20px;
          /* position: sticky; */
          /* top: 0;
          z-index: 2; */
          text-align: center;
          font-size: 10px;
          font-weight: 300;
          border: solid 1px #0000002f;
          border-radius: 5px;
        }
  
        /* Table body styles */
        .table-container td {
          text-align: left;
          margin-top: 15px;
          padding: 0px 5px;
          border: solid 1px #0000002f;
          border-radius: 5px;
        }
  
        .table-container td:first-child {
          /* position: sticky;
          right: 0;
          z-index: 1; */
          /* overflow-y: auto; */
          background-color: white;
        }
  
        .table-container td.exercise-new-session {
          position: sticky;
          right: 140px;
          z-index: 1 !important;
          /* overflow-y: auto; */
          background-color: white;
        }
  
        .table-container th {
          /* position: sticky; */
          top: 0;
          z-index: 1;
          /* overflow: scroll; */
          background-color: white;
        }
  
        .table-container th:first-child {
          z-index: 2;
          right: 0;
        }
  
        .exercise-duration {
          color: var(--fit20-blue);
        }
        .exercise-info {
          font-size: 11px;
          padding-left: 12px !important;
          min-width: 53px;
        }
  
        .exercise-info img {
          padding: 2px 3px 0 0;
        }
  
        .exercise-info div.flex {
          flex-direction: row-reverse;
        }
  
        .exercise-info div.flex span {
          padding-right: 3px;
        }
  
        .day-month {
          display: flex;
          justify-content: space-between;
          padding: 0 10px;
        }
        .machine-box {
          /* border: solid 1px rebeccapurple; */
          width: 130px;
          height: 40px;
          /* margin-top: 1px; */
          /* padding: 5px 0; */
          display: flex;
        }
  
        .machine-box-img-settings-sec {
          width: calc(100% / 5 * 3);
        }
  
        .machine-box-img-settings {
          width: calc(100% / 3 - 4px);
          height: 18px;
          position: relative;
          padding: 2px;
        }
  
        .machine-box-img-settings img {
          width: 100%;
          height: 100%;
        }
  
        .machine-box-img-settings span {
          position: absolute;
          right: 15px;
          top: 0px;
          font-size: 11px;
        }
  
        .machine-box-img {
          width: calc(100% / 5 * 2);
          height: 36px;
          position: relative;
        }
  
        .machine-box-img img {
          width: 100%;
          height: 36px;
        }
        .flex {
          display: flex;
          flex-wrap: wrap;
        }
        .search-sec {
          text-align: center;
        }
        .search-sec input {
          padding: 5px 10px;
          font-size: 16px;
          border: 1px solid #0000002f; /* Custom border */
          border-radius: 5px; /* Rounded corners */
          width: 30%; /* Full width */
          box-sizing: border-box; /* Include padding and border in element's total width and height */
          margin-left: 15px;
          outline: none; /* Optional: Remove default outline */
        }
  
        .search-sec input:focus {
          border-color: #009efb; /* Change border color on focus */
          box-shadow: 0 0 8px rgba(102, 175, 233, 0.6); /* Add a box shadow on focus */
        }
        .studio-name {
          text-align: center;
        }
        .studio-name span {
          text-align: center;
          padding: 8px 50px;
          background-color: #92d400;
          color: white;
          font-size: 18px;
          border-bottom-left-radius: 10px;
          border-bottom-right-radius: 10px;
        }
        .fit20-logo img {
          position: absolute;
        }
      </style>
      <script type="text/javascript">
        function printPage(id) {
          var activeElements = document.querySelectorAll('.printable');
          for (var i = 0; i < activeElements.length; ++i) {
            activeElements[i].className = 'non-printable';
          }
          document.getElementById(id).className = 'printable';
          window.print();
          if (window.stop && navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
            location.reload();
            window.stop();
          }
        }
  
        const search = (e) => {
          console.log(e.target.value);
          const query = e.target.value.toLowerCase();
          const namesContainer = document.getElementById('names');
          const links = namesContainer.getElementsByTagName('a');
  
          for (let i = 0; i < links.length; i++) {
            const linkText = links[i].textContent.toLowerCase();
            if (linkText.includes(query) || query === '') {
              links[i].style.display = 'block'; // Show link if it matches query or if query is empty
            } else {
              links[i].style.display = 'none'; // Hide link if it doesn't match query
            }
          }
        };
      </script>
      </head>
      <body>
      <div class="fit20-logo">
      <img
        width="150"
        src="${machineSettingsImages['fit20-logo']}"
      />
      <div class="studio-name"><span>${capitalizeFirstLetter(studioName)}</span></div>
    </div>
    <br />
      <br />
      <div class="non-printable search-sec">
        <input class="non-printable" type="text" id="search-input" />
      </div>
      <br />
        <div class="names-container non-printable" id="names">
          ${dataToDisplay
            .map(
              (item) =>
                `<a class="non-printable" href="${'#' + item.member.id}">${capitalizeFirstLetter(
                  item.member.firstName,
                )} ${capitalizeFirstLetter(item.member.lastName)}</a>`,
            )
            .join('')}
        </div>
        ${dataToDisplay
          .map(
            (item) => `
            <div class="sessions-sec non-printable" id="${item.member.id}">
              <div class="session-title">
                <div>${capitalizeFirstLetter(item.member.firstName)} ${capitalizeFirstLetter(
              item.member.lastName,
            )}</div>
                <div class="print-btn non-printable" onclick="printPage(${
                  item.member.id
                })">Print</div>
              </div>
              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      <th class="session-remarks-sec"></th>
                      <th class="session-remarks-sec"></th>
                      ${item.sessions
                        .map(
                          (session) => `
                        <th>
                          <div>${session.trainer ? session.trainer.initials : '???'} - <span>${
                            session.number
                          }</span></div>
                          <div>${getWeekYear(session.date)}</div>
                          <div class="day-month">
                            <span>${getMonth(session.date)}</span>
                            <span> </span>
                            <span>${getDay(session.date)}</span>
                          </div>
                        </th>
                      `,
                        )
                        .join('')}
                    </tr>
                  </thead>
                  <tbody class="absent-blocker-container">
                    ${studioMachines
                      .map(
                        (machine) => `
                      <tr>
                        <td>
                          <div class="machine-box">
                            <div class="flex machine-box-img-settings-sec"></div>
                          </div>
                        </td>
                        <td>
                          <div class="machine-box">
                            <div class="flex machine-box-img-settings-sec">
                              ${getMemberMachineSetting(item.member.machinesSettings, machine.id)}
                            </div>
                            <div class="machine-box-img">
                              <img src="${machinesImages[machine.name]}" />
                              ${
                                getExecuteMachineSetting(
                                  item.member.machinesSettings,
                                  machine.id,
                                ) == 1
                                  ? `<img class="execute" src="${machineSettingsImages['execute1']}" />`
                                  : ``
                              }
                              ${
                                getExecuteMachineSetting(
                                  item.member.machinesSettings,
                                  machine.id,
                                ) == 2
                                  ? `<img class="execute" src="${machineSettingsImages['execute2']}" />`
                                  : ``
                              }
                            </div>
                          </div>
                        </td>
                        ${item.sessions
                          .map(
                            (session) => `
                          <td class="exercise-info">
                            ${(session.exercises ? session.exercises : [])
                              .map(
                                (exercise) => `
                              <div>
                                ${
                                  exercise && machine.id == exercise.machineId
                                    ? `
                                  <div class="flex">
                                    <span>${exercise.order}</span>
                                  </div>
                                  <div class="exercise-duration">
                                    ${
                                      exercise.duration
                                        ? secondsToTime(exercise.duration)
                                        : '.. : ..'
                                    }
                                  </div>
                                  <div>${exercise.weight}
                                    ${
                                      exercise.weightChange && exercise.weightChange != 'NONE'
                                        ? `
                                      <span><img width="10" src="${
                                        machineSettingsImages[exercise.weightChange]
                                      }"></span>
                                    `
                                        : ``
                                    }
                                  </div>
                                `
                                    : ``
                                }
                              </div>
                            `,
                              )
                              .join('')}
                          </td>
                        `,
                          )
                          .join('')}
                      </tr>
                    `,
                      )
                      .join('')}
                  </tbody>
                </table>
              </div>
            </div>
          `,
          )
          .join('')}
      </body>
      <script>
      document.getElementById('search-input').addEventListener('input', search);
    </script>
    </html>`;

  return htmlContent;
}

function getCategoryValue(categories, number) {
  for (const category of categories) {
    if (number >= category.from && number <= category.to) {
      return category.value;
    }
  }
  return 0; // Return null or any default value if the number doesn't belong to any category
}

function getClosestAge(weightData, exe, durationTable, qsTable, minAge) {
  if (!weightData[exe.machineName]) {
    return null; // Return null if the machine is not found
  }

  const ages = Object.keys(weightData[exe.machineName]);
  const weights = Object.values(weightData[exe.machineName]);

  let closestAge = ages[0];
  let smallestDifference = Math.abs(exe.weight - weights[0]);

  for (let i = 1; i < weights.length; i++) {
    const difference = Math.abs(Number(exe.weight) - Number(weights[i]));

    if (difference < smallestDifference) {
      smallestDifference = difference;
      closestAge = ages[i];
    }
  }
  let durationScore = getCategoryValue(durationTable, exe.duration);
  let qsScore = getCategoryValue(qsTable, exe.qs);
  closestAge = Number(closestAge) + Number(durationScore) + Number(qsScore);
  if (closestAge < minAge) {
    closestAge = minAge;
  }
  if (closestAge > 85) {
    closestAge = 85;
  }
  return closestAge;
}

function getTrainingAge(
  durationTable,
  qsTable,
  weightedTable,
  trainingAgeTable,
  sessions,
  qsType,
  machines,
  minAge,
) {
  const trainingAges = [];
  sessions.map((session) => {
    if (
      session.training_age &&
      session.training_age.train_at_level &&
      session.training_age.train_at_level > 15
    ) {
      trainingAges.push(session.training_age.train_at_level);
    } else {
      let oneSessionTa = calcOneSessionTrainingAge(
        durationTable,
        qsTable,
        weightedTable,
        trainingAgeTable,
        session,
        qsType,
        machines,
        minAge,
      );
      if (oneSessionTa > 15) {
        trainingAges.push(oneSessionTa);
      }
    }
  });

  return trainingAges.length > 0
    ? Math.round(trainingAges.reduce((sum, num) => sum + num, 0) / trainingAges.length)
    : 0;
}
// this fun used only inside getTrainingAge
const calcOneSessionTrainingAge = (
  durationTable,
  qsTable,
  weightedTable,
  trainingAgeTable,
  session,
  qsType,
  machines,
  minAge,
) => {
  if (session.exercises.length < 4) return 0;
  let weightedSum = 0;
  let totalWeight = 0;
  session.exercises.forEach((exe) => {
    if (exe.duration && exe.duration > 30) {
      const machine = machines.find((m) => m.id === exe.machineId);

      if (!machine) return;

      const qsValue = exe[qsType] > 30 ? exe[qsType] : 0; // Keep the QS logic
      const trainingAge = getClosestAge(
        trainingAgeTable,
        { ...exe, qs: qsValue, machineName: machine.name },
        durationTable,
        qsTable,
        minAge,
      );

      if (!trainingAge) return;

      const weight = Number(weightedTable[machine.name]);

      if (!weight) return;

      weightedSum += trainingAge * weight;
      totalWeight += weight;
    }
  });

  return totalWeight > 0 ? Math.round(weightedSum / totalWeight) : 0;

  // if (session.exercises.length >= 4 && !session.training_age.train_at_level) {
  //   session.exercises.map((exe) => {
  //     if (exe.duration && exe.duration > 30) {
  //       let machine = machines.find((machine) => machine.id == exe.machineId);
  //       let machineName = machine ? machine.name : false;
  //       exe['machineId'] = machineName;
  //       exe['qs'] = exe[qsType] > 30 ? exe[qsType] : 0;
  //       exe['trainingAge'] = getClosestAge(trainingAgeTable, exe, durationTable, qsTable, minAge);
  //       if (exe.trainingAge && exe.machineId) {
  //         weightedSum += exe.trainingAge * Number(weightedTable[exe.machineId]);
  //         totalWeight += Number(weightedTable[exe.machineId]);
  //         console.log(Number(weightedTable[exe.machineId]));
  //       }
  //     }
  //   });
  //   console.log(session);
  //   return Math.round(weightedSum / totalWeight);
  // } else {
  //   session.training_age.train_at_level =
  //     session.training_age.train_at_level > 15
  //       ? Math.round(session.training_age.train_at_level)
  //       : 0;
  //   console.log(session);
  //   return session.training_age.train_at_level || Math.round(weightedSum / totalWeight);
  // }

  // session.exercises.forEach((item) => {
  //   if (item.trainingAge && item.machineId) {
  //     weightedSum += item.trainingAge * Number(weightedTable[item.machineId]);
  //     totalWeight += Number(weightedTable[item.machineId]);
  //     console.log(Number(weightedTable[item.machineId]));
  //   }
  // });
};

const formattedDateTime = () => {
  const now = new Date();
  return now.toLocaleString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
};

function getErrorReportStr(data, description, img) {
  let errors =
    data.errors.length > 150
      ? [data.errors[0], data.errors[1], ...data.errors.slice(-150)]
      : data.errors;
  let htmlContent = `
                     <div>Studio:${data.studio.email ? data.studio.email : 'unknown'}</div>
                     <div>Server:${window.location.host}</div>
                     <div>User:${data.user.email}</div>
                     <div>Message:${description}</div>
                     <br>
                     ${errors.map(
                       (err) => `
                      <div>${err}</div>
                      `,
                     )}
                      <br>
                     ${data.logs.map(
                       (log) => `
                      <div>${log}</div>
                      `,
                     )}
                     <div> <a href="${
                       data.storageBaseUrl + '/errors/' + img
                     }">Link to screenshot</a>`;
  return htmlContent;
}

export {
  capitalizeFirstLetter,
  randomMsg,
  getStudioReportStr,
  getTrainingAge,
  formattedDateTime,
  isValidEmail,
  getErrorReportStr,
};
